import { render, staticRenderFns } from "./AccountPasswordForm.vue?vue&type=template&id=8143ced8&"
import script from "./AccountPasswordForm.vue?vue&type=script&lang=js&"
export * from "./AccountPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports